import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Login from "./views/NewLogin";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/set-password",
            name: "SetPassword",
            component: () => import("./views/SetPassword")
        },

        {
            path: "/",
            name: "index",
            meta: {tab: false},
            component: Index,
            redirect: "/home",
            children: [
                {
                    path: "/image-upload-demo",
                    name: "image-upload-demo",
                    meta: {title: "图片上传调试", tab: true},
                    component: () => import("./views/demo/ImageUploadDemo")
                },

                {
                    path: "/home",
                    name: "home-list",
                    meta: {title: "首页", tab: true},
                    component: () => import("./views/home/List")
                },
                {
                    path: "/password-edit",
                    name: "password-edit",
                    meta: {title: "修改密码", tab: true},
                    component: () => import("./views/edit-password/Edit")
                },
                {
                    path: "/personage-detail",
                    name: "personage-detail",
                    meta: {title: "个人中心", tab: true},
                    component: () => import("./views/personage/Detail")
                },

                {
                    path: "/apk-list",
                    name: "apk-list",
                    meta: {title: "APK管理", tab: true},
                    component: () => import("./views/apk/List")
                },
                {
                    path: "/apk-detail",
                    name: "apk-detail",
                    meta: {title: "子包资料", tab: true},
                    component: () => import("./views/apk/Detail")
                },
                {
                    path: "/apk-add",
                    name: "apk-add",
                    meta: {title: "新增子包资料", tab: true},
                    component: () => import("./views/apk/Add")
                },
                {
                    path: "/apk-edit",
                    name: "apk-edit",
                    meta: {title: "编辑子包资料", tab: true},
                    component: () => import("./views/apk/Edit")
                },

                {
                    path: "/device-info-list",
                    name: "device-info-list",
                    meta: {title: "设备信息", tab: true},
                    component: () => import("./views/device-info/List")
                },
                {
                    path: "/device-info-detail",
                    name: "device-info-detail",
                    meta: {title: "查看设备", tab: true},
                    component: () => import("./views/device-info/Detail")
                },

                {
                    path: "/fault-collect-detail",
                    name: "fault-collect-detail",
                    meta: {title: "故障汇总", tab: true},
                    component: () => import("./views/fault-collect/Detail")
                },
                {
                    path: "/fault-record-list",
                    name: "fault-record-list",
                    meta: {title: "报障记录", tab: true},
                    component: () => import("./views/fault-record/List")
                },

                {
                    path: "/test-device-list",
                    name: "test-device-list",
                    meta: {title: "测试设备组", tab: true},
                    component: () => import("./views/test-device/List")
                },
                {
                    path: "/test-device-detail",
                    name: "test-device-detail",
                    meta: {title: "查看设备信息", tab: true},
                    component: () => import("./views/test-device/Detail")
                },
                {
                    path: "/test-device-add",
                    name: "test-device-add",
                    meta: {title: "新增测试设备", tab: true},
                    component: () => import("./views/test-device/Add")
                },
                {
                    path: "/test-device-edit",
                    name: "test-device-edit",
                    meta: {title: "编辑测试设备", tab: true},
                    component: () => import("./views/test-device/Edit")
                },

                {
                    path: "/user-list",
                    name: "user-list",
                    meta: {title: "普通用户", tab: true},
                    component: () => import("./views/user/List")
                },
                {
                    path: "/user-detail",
                    name: "user-detail",
                    meta: {title: "查看用户", tab: true},
                    component: () => import("./views/user/Detail")
                },

                {
                    path: "/vip-user-list",
                    name: "vip-user-list",
                    meta: {title: "付费用户", tab: true},
                    component: () => import("./views/vip-user/List")
                },

                {
                    path: "/fitting-list",
                    name: "fitting-list",
                    meta: {title: "配件库", tab: true},
                    component: () => import("./views/fitting/List")
                },
                {
                    path: "/fitting-add",
                    name: "fitting-add",
                    meta: {title: "新增配件", tab: true},
                    component: () => import("./views/fitting/Add")
                },
                {
                    path: "/fitting-edit",
                    name: "fitting-edit",
                    meta: {title: "编辑配件", tab: true},
                    component: () => import("./views/fitting/Edit")
                },

                {
                    path: "/lock-screen-ads-list",
                    name: "lock-screen-ads-list",
                    meta: {title: "锁屏广告图", tab: true},
                    component: () => import("./views/lock-screen-ads/List")
                },
                {
                    path: "/lock-screen-ads-add",
                    name: "lock-screen-ads-add",
                    meta: {title: "新增锁屏广告图", tab: true},
                    component: () => import("./views/lock-screen-ads/Add")
                },
                {
                    path: "/lock-screen-ads-edit",
                    name: "lock-screen-ads-edit",
                    meta: {title: "编辑锁屏广告图", tab: true},
                    component: () => import("./views/lock-screen-ads/Edit")
                },

                {
                    path: "/hot-tag-list",
                    name: "hot-tag-list",
                    meta: {title: "热门搜索标签", tab: true},
                    component: () => import("./views/hot-tag/List")
                },
                {
                    path: "/hot-tag-add",
                    name: "hot-tag-add",
                    meta: {title: "新增热门标签", tab: true},
                    component: () => import("./views/hot-tag/Add")
                },
                {
                    path: "/hot-tag-edit",
                    name: "hot-tag-edit",
                    meta: {title: "编辑热门标签", tab: true},
                    component: () => import("./views/hot-tag/Edit")
                },

                {
                    path: "/user-search-record-list",
                    name: "user-search-record-list",
                    meta: {title: "用户搜索记录", tab: true},
                    component: () => import("./views/user-search-record/List")
                },

                {
                    path: "/inform-list",
                    name: "inform-list",
                    meta: {title: "通知", tab: true},
                    component: () => import("./views/inform/List")
                },
                {
                    path: "/inform-add",
                    name: "inform-add",
                    meta: {title: "创建通知", tab: true},
                    component: () => import("./views/inform/Add")
                },
                {
                    path: "/inform-edit",
                    name: "inform-edit",
                    meta: {title: "编辑通知", tab: true},
                    component: () => import("./views/inform/Edit")
                },
                {
                    path: "/inform-detail",
                    name: "inform-detail",
                    meta: {title: "查看通知", tab: true},
                    component: () => import("./views/inform/Detail")
                },

                {
                    path: "/recipe-list",
                    name: "recipe-list",
                    meta: {title: "食谱库", tab: true, keepAlive: true},
                    component: () => import("./views/recipe/List")
                },
                {
                    path: "/recipe-add",
                    name: "recipe-add",
                    meta: {title: "新增食谱", tab: true, keepAlive: true},
                    component: () => import("./views/recipe/Add")
                },
                {
                    path: "/recipe-edit",
                    name: "recipe-edit",
                    meta: {title: "编辑食谱", tab: true, keepAlive: true},
                    component: () => import("./views/recipe/Edit")
                },
                {
                    path: "/preview-detail",
                    name: "preview-detail",
                    meta: {title: "预览食谱", tab: true},
                    component: () => import("./views/preview/Detail")
                },
                {
                    path: "/recipe-model",
                    name: "recipe-model",
                    meta: {title: "批量关联型号", tab: true},
                    component: () => import("./views/recipe/Model")
                },
                {
                    path: "/recipe-detail",
                    name: "recipe-detail",
                    meta: {title: "查看食谱", tab: true},
                    component: () => import("./views/recipe/Detail")
                },
                {
                    path: "/user-evaluation-list",
                    name: "user-evaluation-list",
                    meta: {title: "用户评价", tab: true},
                    component: () => import("./views/user-evaluation/List")
                },
                {
                    path: "/user-evaluation-add",
                    name: "user-evaluation-add",
                    meta: {title: "新增评价", tab: true},
                    component: () => import("./views/user-evaluation/Add")
                },
                {
                    path: "/recycling-list",
                    name: "recycling-list",
                    meta: {title: "回收站", tab: true},
                    component: () => import("./views/recycling/List")
                },

                {
                    path: "/lang-set-edit",
                    name: "lang-set-edit",
                    meta: {title: "语言设置", tab: true},
                    component: () => import("./views/lang-set/Edit")
                },

                {
                    path: "/category-set-list",
                    name: "category-set-list",
                    meta: {title: "分类设置", tab: true},
                    component: () => import("./views/category-set/List")
                },
                {
                    path: "/category-set-add",
                    name: "category-set-add",
                    meta: {title: "新增分类", tab: true},
                    component: () => import("./views/category-set/Add")
                },
                {
                    path: "/category-set-edit",
                    name: "category-set-edit",
                    meta: {title: "编辑分类", tab: true},
                    component: () => import("./views/category-set/Edit")
                },

                {
                    path: "/online-cate/list",
                    name: "online-cate-list",
                    meta: {title: "在线食谱分类", tab: true},
                    component: () => import("./views/online-cate/List")
                },
                {
                    path: "/online-cate/add",
                    name: "online-cate-add",
                    meta: {title: "新增在线食谱分类", tab: true},
                    component: () => import("./views/online-cate/Add")
                },
                {
                    path: "/online-cate/detail",
                    name: "online-cate-detail",
                    meta: {title: "在线食谱分类", tab: true},
                    component: () => import("./views/online-cate/Detail")
                },
                {
                    path: "/online-cate/recipeList",
                    name: "online-cate-recipe-list",
                    meta: {title: "在线食谱分类", tab: true},
                    component: () => import("./views/online-cate/RecipeList")
                },

                {
                    path: "/tag-list",
                    name: "tag-list",
                    meta: {title: "标签库", tab: true},
                    component: () => import("./views/tag/List")
                },
                {
                    path: "/tag-add",
                    name: "tag-add",
                    meta: {title: "新增标签", tab: true},
                    component: () => import("./views/tag/Add")
                },
                {
                    path: "/tag-edit",
                    name: "tag-edit",
                    meta: {title: "编辑标签", tab: true},
                    component: () => import("./views/tag/Edit")
                },

                {
                    path: "/pay-recipe-list",
                    name: "pay-recipe-list",
                    meta: {title: "付费食谱", tab: true},
                    component: () => import("./views/pay-recipe/List")
                },

                {
                    path: "/online-recipe-list",
                    name: "online-recipe-list",
                    meta: {title: "在线食谱", tab: true},
                    component: () => import("./views/online-recipe/List")
                },

                {
                    path: "/offline-recipes-list",
                    name: "offline-recipes-list",
                    meta: {title: "离线食谱包", tab: true},
                    component: () => import("./views/offline-recipes/List")
                },
                {
                    path: "/offline-recipes-add",
                    name: "offline-recipes-add",
                    meta: {title: "新增离线食谱包", tab: true},
                    component: () => import("./views/offline-recipes/Add")
                },
                {
                    path: "/offline-recipes-edit",
                    name: "offline-recipes-edit",
                    meta: {title: "编辑离线食谱包", tab: true},
                    component: () => import("./views/offline-recipes/Edit")
                },
                {
                    path: "/banner/list",
                    name: "banner-list",
                    meta: {title: "Banner管理", tab: true},
                    component: () => import("./views/banner/List")
                },
                {
                    path: "/banner/add",
                    name: "BannerAdd",
                    meta: {title: "新增Banner", tab: true, keepAlive: true},
                    component: () => import("./views/banner/Add")
                },
                {
                    path: "/banner/edit",
                    name: "BannerEdit",
                    meta: {title: "编辑Banner", tab: true, keepAlive: true},
                    component: () => import("./views/banner/Edit")
                },
                {
                    path: "/banner/detail",
                    name: "banner-detail",
                    meta: {title: "Banner详情", tab: true},
                    component: () => import("./views/banner/Detail")
                },
                {
                    path: "/banner/recipe",
                    name: "banner-recipe",
                    meta: {title: "选择食谱", tab: true},
                    component: () => import("./views/banner/BannerRecipe")
                },
                {
                    path: "/group-recipe/list",
                    name: "group-recipe-list",
                    meta: {title: "专题菜谱", tab: true},
                    component: () => import("./views/group-recipe/List")
                },
                {
                    path: "/group-recipe/detail",
                    name: "group-recipe-detail",
                    meta: {title: "专题详情", tab: true},
                    component: () => import("./views/group-recipe/Detail")
                },
                {
                    path: "/group-recipe/add",
                    name: "group-recipe-add",
                    meta: {title: "新增专题食谱", tab: true},
                    component: () => import("./views/group-recipe/Add")
                },
                {
                    path: "/group-recipe/edit",
                    name: "group-recipe-edit",
                    meta: {title: "编辑专题食谱", tab: true},
                    component: () => import("./views/group-recipe/Edit")
                },
                {
                    path: "/group-recipe/recipeList",
                    name: "group-recipe-recipeList",
                    meta: {title: "选择食谱", tab: true},
                    component: () => import("./views/group-recipe/RecipeList")
                },

            ]
        }
    ]
});
